require('./creditHeaderBar.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const ComparativeBar = require('components/commons/comparativeBar/comparativeBar');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@utilities
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class CreditHeaderBar extends React.Component {
    render() {
        const { immCredit } = this.props;

        const limit = immCredit.get('limit');
        const available = immCredit.get('available');
        const disposed = immCredit.get('disposed');
        const plainAmountDisposedObject = getPlainAmountObject(disposed);
        const plainAmountAvailableObject = getPlainAmountObject(available);
        const plainAmountLimitObject = getPlainAmountObject(limit);
        const limitAmount = limit.get('amount');
        const disposedAmount = disposed.get('amount');
        const language = getLanguage();

        return (
            <article className="credit-header-bar">
                <div className="credit-header-bar__label credit-header-bar__label--left">
                    <span className="credit-header-bar__dot credit-header-bar__dot--disposed"></span>
                    <FormattedText value="creditHeaderBar-disposedLabel" />
                    <OneLineSymbolAmount
                        className="credit-header-bar__amount credit-header-bar__amount--disposed"
                        amountObject={plainAmountDisposedObject}
                        positiveAmount={true}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountDisposedObject, true)} />
                </div>
                <div className="credit-header-bar__label">
                    <span className="credit-header-bar__dot credit-header-bar__dot--available" ></span>
                    <FormattedText value="creditHeaderBar-availabelLabel" />
                    <OneLineSymbolAmount
                        className="credit-header-bar__amount credit-header-bar__amount--available"
                        amountObject={plainAmountAvailableObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountAvailableObject, true)}/>
                </div>
                <div className="credit-header-bar__bar">
                    <ComparativeBar
                        firstValue={disposedAmount}
                        totalValue={limitAmount}
                    />
                </div>
                <div className="credit-header-bar__label">
                    <FormattedText value="creditHeaderBar-limitLabel" />
                    <OneLineSymbolAmount
                        className="credit-header-bar__amount credit-header-bar__amount--limit"
                        amountObject={plainAmountLimitObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountLimitObject, true)}/>
                </div>
            </article>
        );
    }
}

CreditHeaderBar.propTypes = {
    immCredit: PropTypes.object.isRequired
};

module.exports = CreditHeaderBar;
